import React, { useState } from 'react';
import { getBgColor } from '@/components/features/casino/crash/GameBox/utils';
import { crashHistoryState } from '@/components/features/casino/crash/state';
import { Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import CrashHistory from '../CrashHistory';
import DetailModal from '../CrashHistory/DetailModal';
import { BoxChip, PreviousRoundResultBox } from './styles';
import { crashLatest } from '@/apis/casino/crash';
import { getMultiplier } from '@/components/features/casino/crash/utils';
import useTheme from '@/theme/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';

export const PreviousRoundResult: React.FC = () => {
  const { theme } = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const showDetail = (item) => {
    setIsOpen(true);
    setRowData(item);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [rowData, setRowData] = useState(null);
  const [list, setList] = useAtom(crashHistoryState);
  // 手机端展示4个
  const { isLoading, error } = useQuery({
    queryKey: ['CrashLatestFive'],
    queryFn: async () =>
      crashLatest({
        page: 1,
        pageSize: 5,
      }),
    onSuccess: (res) => {
      if (res.status.code === '0') {
        setList(res.data.games);
      }
    },
  });

  if (isLoading) {
    return (
      <PreviousRoundResultBox direction="row" spacing={1}>
        {Array.from({ length: 5 }).map((item, index) => {
          return (
            <Skeleton
              key={index}
              variant="rounded"
              width={40}
              height={18}
            ></Skeleton>
          );
        })}
      </PreviousRoundResultBox>
    );
  }
  return (
    <>
      <PreviousRoundResultBox direction="row" spacing={0.5}>
        {list.map((item, index) => {
          const result = Number(item.result);
          const color = getBgColor(result);
          return (
            <BoxChip
              key={item.id}
              label={`${getMultiplier(result)}`}
              sx={(theme) => ({
                color: theme.palette.text.primary,
                border: `1px solid ${getBgColor(result, 1)}`,
                background: color,
                '&:hover': {
                  background: color,
                },
              })}
              onClick={() => {
                showDetail(item);
              }}
            />
          );
        })}
        <CrashHistory />
        <DetailModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          rowData={rowData}
        />
      </PreviousRoundResultBox>
    </>
  );
};

export default PreviousRoundResult;
